import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomahabaleshwarcabsedan() {



  const cardData = {




keyword: "Pune to Mahabaleshwar Sedan Cab",

headingDescription: "Garud Cab Service provides comfortable and reliable Pune to Mahabaleshwar Sedan Cab Service for couples, families, senior citizens, and small groups planning a relaxing hill-station journey. Our chauffeur-driven sedans are suitable for one-way travel, round trips, weekend trips, sightseeing, and customized Mahabaleshwar travel plans. With clean and well-maintained cars, experienced drivers, flexible pickup locations across Pune, comfortable seating, convenient luggage space, transparent pricing, and 24/7 customer assistance, we make the journey smooth and convenient. Customers can also include nearby hill stations, temples, viewpoints, strawberry farms, lakes, and scenic attractions in their itinerary while enjoying private door-to-door transportation.",

topPlaces: [
  {
    title: "Venna Lake",
    description: "Venna Lake is one of Mahabaleshwar's most popular attractions, surrounded by greenery and pleasant hill scenery. Visitors can enjoy boating, relaxed walks, and the peaceful atmosphere around the lake. A sedan cab from Pune is a comfortable choice for couples, families, and small groups who want convenient access to Venna Lake as part of their Mahabaleshwar sightseeing plan."
  },
  {
    title: "Mapro Garden",
    description: "Mapro Garden is a popular attraction near Mahabaleshwar known for strawberries, fruit-based products, gardens, snacks, and family-friendly experiences. It is a convenient stop for travelers exploring the Panchgani-Mahabaleshwar region. Garud Cab Service provides private sedan transportation from Pune, allowing passengers to visit Mapro Garden along with other nearby attractions without depending on fixed transport schedules."
  },
  {
    title: "Pratapgad Fort",
    description: "Pratapgad Fort is a historic hill fort associated with Chhatrapati Shivaji Maharaj and offers impressive views of the surrounding Sahyadri mountains. Its historic significance makes it an important destination for travelers interested in Maharashtra's heritage. Customers booking a Pune to Mahabaleshwar sedan cab can include Pratapgad in a customized sightseeing itinerary with flexible travel timings."
  },
  {
    title: "Arthur's Seat",
    description: "Arthur's Seat is one of the well-known viewpoints in the Mahabaleshwar region and offers panoramic views of valleys, hills, and surrounding landscapes. It is especially attractive for photography and nature lovers. A private sedan provides convenient transportation for couples and families who want to visit Arthur's Seat and other viewpoints during their Mahabaleshwar trip."
  },
  {
    title: "Elephant's Head Point",
    description: "Elephant's Head Point is a scenic viewpoint known for its distinctive rock formation and wide views of the surrounding Sahyadri ranges. The location is popular among visitors looking for beautiful mountain scenery and fresh hill air. Garud Cab Service can include this attraction in a flexible Mahabaleshwar sightseeing route from Pune with comfortable chauffeur-driven transportation."
  },
  {
    title: "Panch Ganga Temple",
    description: "Panch Ganga Temple is an important religious attraction in Mahabaleshwar where five rivers are traditionally associated with the sacred site. The temple provides a peaceful spiritual experience alongside the natural beauty of the hill station. Families and devotees traveling from Pune can conveniently visit the temple using a private sedan cab as part of their customized itinerary."
  },
  {
    title: "Krishnabai Temple",
    description: "Krishnabai Temple is a historic temple in the Old Mahabaleshwar area known for its traditional architecture and spiritual significance. The surrounding region provides beautiful views and a peaceful environment away from busy tourist areas. Travelers can include Krishnabai Temple in their Pune to Mahabaleshwar sedan cab booking and explore other nearby religious attractions comfortably."
  },
  {
    title: "Panchgani",
    description: "Panchgani is a picturesque hill station located near Mahabaleshwar and is known for Table Land, scenic valleys, viewpoints, strawberry farms, and pleasant weather. Many travelers combine both destinations during the same road trip. A private sedan from Pune provides flexibility to cover Panchgani and Mahabaleshwar together according to the customer's preferred sightseeing schedule."
  },
  {
    title: "Table Land",
    description: "Table Land in Panchgani is a large elevated plateau offering panoramic views of the surrounding valleys and hills. It is a popular attraction for families, couples, and visitors exploring the Panchgani region. Customers can extend their Mahabaleshwar cab itinerary to include Table Land while enjoying comfortable private transportation throughout the journey."
  },
  {
    title: "Lingmala Waterfall",
    description: "Lingmala Waterfall is a beautiful natural attraction near Mahabaleshwar surrounded by lush greenery and forested hills. The waterfall is particularly attractive during and after the monsoon season when the surrounding landscape becomes vibrant. Garud Cab Service provides comfortable sedan transportation for travelers who want to include Lingmala Waterfall along with other Mahabaleshwar sightseeing locations."
  }
],




"services": [
{
"name": "Pune to Mahabaleshwar Sedan Cab Service",
"description": "Book Pune to Mahabaleshwar Sedan Cab Service for a comfortable and convenient hill-station journey with professional chauffeurs and well-maintained air-conditioned sedans. The service is suitable for families, couples, tourists, small groups, weekend travelers, sightseeing trips, and private outstation transportation from Pune to Mahabaleshwar."
},
{
"name": "Pune to Mahabaleshwar Sedan Cab",
"description": "Choose Pune to Mahabaleshwar Sedan Cab for comfortable private transportation with an experienced chauffeur and convenient pickup arrangements. Enjoy AC interiors, comfortable seating, practical luggage space, and flexible travel options for family holidays, sightseeing, personal visits, and weekend trips."
},
{
"name": "Pune to Mahabaleshwar Sedan Taxi",
"description": "Reserve Pune to Mahabaleshwar Sedan Taxi for a smooth and private journey in a comfortable air-conditioned sedan. Professional chauffeur service, convenient pickup, and direct destination drop make the service suitable for couples, families, tourists, business travelers, and small groups."
},
{
"name": "Pune to Mahabaleshwar Cab Service",
"description": "Book Pune to Mahabaleshwar Cab Service for reliable outstation transportation with professional chauffeurs and clean AC vehicles. Choose a suitable sedan for comfortable travel between Pune and Mahabaleshwar, with flexible arrangements for one-way transfers, round trips, sightseeing, and extended holidays."
},
{
"name": "Pune to Mahabaleshwar Taxi Service",
"description": "Choose Pune to Mahabaleshwar Taxi Service for dependable private travel with experienced drivers, comfortable AC interiors, and convenient pickup and drop facilities. The service is suitable for families, couples, tourists, weekend travelers, corporate passengers, and groups planning a Mahabaleshwar trip."
},
{
"name": "Pune to Mahabaleshwar Sedan Cab Booking",
"description": "Make Pune to Mahabaleshwar Sedan Cab Booking for a scheduled private journey with convenient pickup and direct destination drop. Select a comfortable sedan according to your passenger count, luggage requirements, travel date, and itinerary while enjoying professional chauffeur service throughout the trip."
},
{
"name": "Pune to Mahabaleshwar One Way Sedan Cab",
"description": "Book Pune to Mahabaleshwar One Way Sedan Cab for a direct point-to-point journey without arranging return transportation. Enjoy comfortable AC travel, professional chauffeur service, convenient pickup, and practical luggage space for individuals, couples, families, and tourists traveling to Mahabaleshwar."
},
{
"name": "Pune to Mahabaleshwar Round Trip Sedan Cab",
"description": "Reserve Pune to Mahabaleshwar Round Trip Sedan Cab for convenient return transportation according to your planned itinerary. Enjoy private AC travel, comfortable seating, professional chauffeur service, and flexible sightseeing arrangements suitable for weekend holidays, family trips, couples, and tourist groups."
},
{
"name": "Pune to Mahabaleshwar Sedan Taxi Booking",
"description": "Book Pune to Mahabaleshwar Sedan Taxi Booking for a comfortable private journey with scheduled pickup and destination drop. The sedan is suitable for families, couples, tourists, and small groups requiring convenient transportation for sightseeing, hotel transfers, personal visits, and hill-station holidays."
},
{
"name": "Pune to Mahabaleshwar Outstation Sedan Cab",
"description": "Choose Pune to Mahabaleshwar Outstation Sedan Cab for comfortable long-distance transportation with a professional chauffeur and well-maintained AC vehicle. The service is suitable for one-way travel, round trips, family holidays, weekend journeys, sightseeing, hotel transfers, and personal visits."
},
{
"name": "Pune to Mahabaleshwar Private Sedan Cab",
"description": "Hire Pune to Mahabaleshwar Private Sedan Cab for a personalized journey without sharing the vehicle with other passengers. Enjoy comfortable AC seating, direct pickup, professional chauffeur service, practical luggage capacity, and flexible travel arrangements for families, couples, tourists, and small groups."
},
{
"name": "Pune to Mahabaleshwar Family Sedan Cab",
"description": "Book Pune to Mahabaleshwar Family Sedan Cab for a comfortable family journey with private chauffeur-driven transportation. The air-conditioned sedan provides comfortable seating and luggage space for families traveling with children or senior passengers for holidays, sightseeing, hotel transfers, and weekend trips."
},
{
"name": "Pune to Mahabaleshwar Online Cab Booking",
"description": "Make Pune to Mahabaleshwar Online Cab Booking for convenient scheduled transportation with private pickup and direct destination drop. Select a suitable sedan according to passenger capacity, luggage requirements, travel timing, and itinerary for a comfortable and hassle-free journey to Mahabaleshwar."
},
{
"name": "Pune to Mahabaleshwar Tourist Sedan Cab",
"description": "Choose Pune to Mahabaleshwar Tourist Sedan Cab for convenient private sightseeing and holiday transportation with an experienced chauffeur. Enjoy comfortable AC travel and flexible stops for exploring Mahabaleshwar viewpoints, markets, attractions, hotels, and nearby destinations according to your planned itinerary."
},
{
"name": "Pune to Mahabaleshwar Affordable Sedan Cab",
"description": "Book Pune to Mahabaleshwar Affordable Sedan Cab for practical and comfortable outstation transportation at a suitable travel option for individuals, couples, families, and small groups. Enjoy AC interiors, comfortable seating, professional chauffeur service, convenient pickup, and flexible one-way or round-trip travel."
},
{
"name": "Pune to Mahabaleshwar Sedan Car Hire",
"description": "Hire Pune to Mahabaleshwar Sedan Car Hire with a professional chauffeur for a relaxed and convenient hill-station journey. The sedan offers comfortable AC interiors, practical luggage space, and flexible travel arrangements for families, couples, tourists, business travelers, and weekend holidaymakers."
},
{
"name": "Pune to Mahabaleshwar Sedan Car Rentals",
"description": "Choose Pune to Mahabaleshwar Sedan Car Rentals for private chauffeur-driven transportation with comfortable AC seating and convenient travel arrangements. Sedan options are suitable for one-way transfers, round trips, sightseeing, family holidays, hotel transfers, and personal journeys between Pune and Mahabaleshwar."
}
],
"tableData": [
["Pune to Mahabaleshwar Sedan Cab Service", "Pune to Mahabaleshwar Sedan Cab"],
["Pune to Mahabaleshwar Sedan Taxi", "Pune to Mahabaleshwar Cab Service"],
["Pune to Mahabaleshwar Taxi Service", "Pune to Mahabaleshwar Sedan Cab Booking"],
["Pune to Mahabaleshwar One Way Sedan Cab", "Pune to Mahabaleshwar Round Trip Sedan Cab"],
["Pune to Mahabaleshwar Sedan Taxi Booking", "Pune to Mahabaleshwar Outstation Sedan Cab"],
["Pune to Mahabaleshwar Private Sedan Cab", "Pune to Mahabaleshwar Family Sedan Cab"],
["Pune to Mahabaleshwar Online Cab Booking", "Pune to Mahabaleshwar Tourist Sedan Cab"],
["Pune to Mahabaleshwar Affordable Sedan Cab", "Pune to Mahabaleshwar Sedan Car Hire"],
["Pune to Mahabaleshwar Sedan Car Rentals", "Pune to Mahabaleshwar Sedan Cab Service"]
],



whychoose: [
  {
    WhyChooseheading: "Pune to Mahabaleshwar Sedan Cab for a Scenic Getaway",
    WhyChoosedescription: "Garud Cab Service offers private sedan cabs from Pune to Mahabaleshwar for couples, families, small groups, and travellers planning a comfortable hill-station escape with convenient pickup and drop arrangements."
  },
  {
    WhyChooseheading: "Smooth Travel to the Hill Station",
    WhyChoosedescription: "A dedicated sedan provides a relaxed way to travel from Pune to Mahabaleshwar, with direct transportation, comfortable seating, and the flexibility to plan breaks according to your journey."
  },
  {
    WhyChooseheading: "Perfect for Couples & Small Families",
    WhyChoosedescription: "Sedan cabs are a practical choice for couples and small families who want private transportation for a weekend holiday, honeymoon, family vacation, or short Mahabaleshwar getaway."
  },
  {
    WhyChooseheading: "One-Way and Round-Trip Booking",
    WhyChoosedescription: "Book a one-way cab if you are continuing your trip from Mahabaleshwar, or choose a round-trip arrangement when you want to return to Pune after your stay."
  },
  {
    WhyChooseheading: "Mahabaleshwar Sightseeing at Your Pace",
    WhyChoosedescription: "Your trip can be planned to include attractions such as Venna Lake, Mapro Garden, Arthur's Seat, Elephant's Head Point, Wilson Point, Pratapgad Fort, and other nearby places according to your itinerary."
  },
  {
    WhyChooseheading: "Convenient Pickup from Pune",
    WhyChoosedescription: "Start your journey from your home, hotel, office, residential society, or another preferred location in Pune and travel directly to your Mahabaleshwar hotel, resort, or selected destination."
  },
  {
    WhyChooseheading: "Useful for Weekend & Holiday Plans",
    WhyChoosedescription: "Whether you are planning a weekend break, monsoon outing, family holiday, honeymoon, or sightseeing trip, a private sedan gives you flexibility over departure and return timings."
  },
  {
    WhyChooseheading: "Plan Your Mahabaleshwar Ride with Garud",
    WhyChoosedescription: "Provide your Pune pickup point, Mahabaleshwar destination, travel date, passenger count, sightseeing requirements, and one-way or return preference to arrange your sedan cab."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune to Mahabaleshwar Sedan Cab Service?",
    answer: "Yes, Garud Cab Service provides sedan cabs from Pune to Mahabaleshwar for weekend trips, family holidays, couples, sightseeing, and outstation travel."
  },
  {
    question: "Can I book a one-way sedan from Pune to Mahabaleshwar?",
    answer: "Yes, one-way sedan cab service is available for passengers who need direct transportation from Pune to Mahabaleshwar."
  },
  {
    question: "Can I book a round-trip Mahabaleshwar sedan?",
    answer: "Yes, round-trip cab arrangements can be planned according to your hotel stay, sightseeing schedule, and preferred return date."
  },
  {
    question: "Is a sedan suitable for a Mahabaleshwar family trip?",
    answer: "Yes, a sedan is a practical option for couples and small families looking for private and comfortable transportation to Mahabaleshwar."
  },
  {
    question: "Can I include Mahabaleshwar sightseeing?",
    answer: "Yes, sightseeing can be included according to your itinerary, with places such as Venna Lake, Mapro Garden, Arthur's Seat, Wilson Point, and other suitable attractions."
  },
  {
    question: "Can I get pickup from my home in Pune?",
    answer: "Yes, pickup can be arranged from your home, hotel, office, residential society, or another convenient location in Pune."
  },
  {
    question: "Can the cab drop me directly at my Mahabaleshwar hotel?",
    answer: "Yes, direct drop-off can be arranged at your preferred hotel, resort, homestay, or another accessible destination in Mahabaleshwar."
  },
  {
    question: "Can I book the cab for a weekend getaway?",
    answer: "Yes, sedan cab arrangements are suitable for weekend holidays, short breaks, family outings, honeymoon trips, and sightseeing plans."
  },
  {
    question: "Can I visit Pratapgad during the trip?",
    answer: "Yes, Pratapgad and other nearby attractions can be added to the itinerary depending on your available time and sightseeing preferences."
  },
  {
    question: "How can I book a Pune to Mahabaleshwar Sedan Cab?",
    answer: "Share your Pune pickup location, travel date, passenger count, Mahabaleshwar destination, sightseeing requirements, and trip type with Garud Cab Service to arrange your sedan."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Ritesh Pawar",
    feedback: "We booked a sedan from Pune to Mahabaleshwar for a weekend family trip. The private travel was comfortable and made it easy to manage our hotel and sightseeing plans.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Snehal Joshi",
    feedback: "My husband and I booked a sedan for our Mahabaleshwar getaway. The direct pickup from Pune and flexible return plan made the trip convenient for us.",
    rating: 5
  }
];







  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mahabaleshwar Sedan Cab",
  "image": "https://garudcabs.com/assets/images/pune-to-mahabaleshwar-sedan-cab.webp",
  "description": "Book Pune to Mahabaleshwar Sedan Cab with Garud Cab for safe, comfortable, and convenient travel. Get reliable Sedan cab and taxi services from Pune to Mahabaleshwar, including one way and round trip options, with professional drivers and convenient pickup and drop facilities for family trips, sightseeing, and weekend getaways.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-to-mahabaleshwar-sedan-cab"
  }
};




  return (
    <div>

<Helmet>
  <title>Pune to Mahabaleshwar Sedan Cab | One Way Taxi | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune to Mahabaleshwar Sedan Cab with Garud Cab for comfortable and reliable travel. Get Sedan cab booking, one way taxi, and round trip services from Pune to Mahabaleshwar with convenient pickup and drop options."
  />

  <meta
    name="keywords"
    content="Pune to Mahabaleshwar Sedan Cab Service, Pune to Mahabaleshwar Sedan Cab, Pune to Mahabaleshwar Sedan Taxi, Pune to Mahabaleshwar Cab Service, Pune to Mahabaleshwar Taxi Service, Pune to Mahabaleshwar Sedan Cab Booking, Pune to Mahabaleshwar One Way Sedan Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/39.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomahabaleshwarcabsedan;